'use client';

import { PropsWithChildren, useEffect, useState } from 'react';

const Hydrate = ({ children }: PropsWithChildren) => {
  // we "need" to do that in order to prevent server to render this component
  // Even if its explicitly a client component Next pre-render it server side
  // cf https://tkdodo.eu/blog/avoiding-hydration-mismatches-with-use-sync-external-store
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return children;
};

export default Hydrate;
